module.exports = __webpack_public_path__ + "img/運勢書介紹頁_Mobile.684c6bd2.png";